import { EMPTY_CONVERSATION_ID } from '@atlassian/conversation-assistant-store/controllers/chat';
import type { Conversation } from '@atlassian/conversation-assistant-store/controllers/chat/types';

export const shouldPreserveConversationOnModeSwitch = (
	hasConsumedPreserveIntent: boolean,
	currentConversationId: string | undefined,
	inMemoryConversation: Conversation | undefined,
): boolean => {
	if (
		!hasConsumedPreserveIntent ||
		!currentConversationId ||
		currentConversationId === EMPTY_CONVERSATION_ID
	) {
		return false;
	}

	return Boolean(inMemoryConversation);
};
